import * as React from 'react';
import { Collapse } from '@oscar/theme';
import { get } from 'lodash';
import { getRequestVisibile } from 'features/insulation/utils';
import { NodeItem, RequestDataType, Status } from 'features/insulation';
import { useAuth } from 'features/auth';
import useStatus from '../../hooks/useStatus';
import { isEdit } from '../../utils';

const { Panel } = Collapse;

export interface VisibleViewProps {
  config: RequestDataType;
}

const VisibleView: React.FC<VisibleViewProps> = ({ config }) => {
  const [auth] = useAuth();
  const [statusRequest] = useStatus();
  const visibleView = React.useMemo(() => {
    const result: { [name: string]: NodeItem } = {};
    const expandedView: string[] = [];
    const visible = getRequestVisibile(
      statusRequest?.status,
      Object.keys(config) as Status[],
    );
    visible.Done.map(item => {
      get(config, item, []).forEach(panel => {
        result[panel.key] = panel;
        if (statusRequest.state === 'VIEW') {
          expandedView.push(panel.key);
        }
      });
    });
    visible.Pending.map(item => {
      get(config, item, []).forEach(panel => {
        result[panel.key] = panel;
        if (statusRequest.state === 'VIEW') {
          expandedView.push(panel.key);
        } else if (isEdit(panel.roles, statusRequest, auth)) {
          expandedView.push(panel.key);
        }
      });
    });

    return {
      panels: Object.values(result),
      expandedView,
    };
  }, [statusRequest, config]);

  return visibleView.panels?.length > 0 ? (
    <Collapse defaultActiveKey={visibleView.expandedView}>
      {visibleView.panels.map((panel: any) => {
        const Component = panel.component;
        return (
          <Panel header={panel?.header} key={panel.key}>
            <Component
              statusRequest={{
                ...statusRequest,
                state: isEdit(panel.roles, statusRequest, auth)
                  ? 'EDIT'
                  : 'VIEW',
              }}
            />
          </Panel>
        );
      })}
    </Collapse>
  ) : null;
};

export default VisibleView;
